import { FaChalkboardTeacher, FaCalendarDay, FaUsers, FaTrophy, FaWallet, FaCalendarAlt, FaLightbulb, FaMoneyBillWave, FaPeopleCarry, FaCrown, FaGlobe } from "react-icons/fa";
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Team",
    heading: "Become a Part of Our Wedding Planning Team",
    description: "At Eternal Vows, we're looking for creative and dedicated professionals to join our team. Explore exciting career opportunities in wedding planning and be part of our mission to create unforgettable experiences. Start your journey with us today and help make dreams come true.",
    points: [
        {
            icon: <FaCalendarDay />,
            title: "Creative Work Environment",
        },
        {
            icon: <FaMoneyBillWave />,
            title: "Attractive Compensation",
        },
        {
            icon: <FaPeopleCarry />,
            title: "Team Collaboration",
        },
        {
            icon: <FaCrown />,
            title: "Professional Development",
        },
        {
            icon: <FaGlobe />,
            title: "Opportunities for Growth",
        },
    ]
};

const benefits = [
    {
        id: 1,
        icon: <FaTrophy />,
        title: "Career Advancement",
        description: "Discover numerous opportunities for career growth and advancement within the wedding planning industry. Take on various roles and responsibilities to elevate your career to new heights.",
    },
    {
        id: 2,
        icon: <FaChalkboardTeacher />,
        title: "Training Programs",
        description: "Engage in specialized training programs that enhance your skills in event coordination, client relations, and design. Gain the expertise needed to excel in creating unforgettable weddings.",
    },
    {
        id: 3,
        icon: <FaWallet />,
        title: "Competitive Pay",
        description: "Enjoy competitive salary packages and benefits in the wedding planning sector, rewarding your dedication and providing financial stability while working on elegant events.",
    },
    {
        id: 4,
        icon: <FaCalendarAlt />,
        title: "Flexible Hours",
        description: "Benefit from flexible working hours that accommodate your personal schedule and preferences, supporting a balanced lifestyle while planning exceptional weddings.",
    },
    {
        id: 5,
        icon: <FaUsers />,
        title: "Team Support",
        description: "Work in a collaborative and supportive team environment, where cooperation and mutual assistance are key to delivering top-notch wedding experiences.",
    },
    {
        id: 6,
        icon: <FaLightbulb />,
        title: "Growth Potential",
        description: "Unlock significant opportunities for personal and professional growth, with chances to advance in various roles within the vibrant wedding planning industry.",
    },
];


const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Wedding Planner',
        content: 'Join our creative team as a Wedding Planner and help couples bring their dream weddings to life with flawless execution and stylish coordination.',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Scheduling, Event-Based',
            experience: 'Minimum 2 Years in Event Planning',
            position: 'Single Position Available',
            days: 'Includes Weekends and Evenings',
            salary: '$50K - $65K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are looking for a talented and organized Wedding Planner to coordinate and manage wedding events from concept to completion. You’ll be the point of contact for clients, vendors, and venue staff, ensuring a seamless and memorable experience for every couple.',
        ],
        responsibilities: [
            'Meeting with clients to understand their vision and preferences.',
            'Developing detailed wedding plans and timelines.',
            'Liaising with vendors and venue coordinators.',
            'Managing budgets and logistics for each event.',
            'Overseeing the setup and flow of wedding day activities.',
        ],
        qualifications: [
            'Degree in Hospitality, Event Management, or related field.',
            'Proven experience as a Wedding Planner or Event Coordinator.',
            'Strong communication and negotiation skills.',
            'Attention to detail and excellent organizational abilities.',
            'Ability to handle stress and multitask in high-pressure environments.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Event Coordinator',
        content: 'We are seeking an energetic Event Coordinator to organize memorable events and deliver exceptional experiences.',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Standard Hours with Evening & Weekend Flexibility',
            experience: '1–3 Years in Event Planning or Coordination',
            position: 'Multiple Positions Available',
            days: 'Weekdays with Occasional Weekend Events',
            salary: '$45K - $55K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'As an Event Coordinator, you will play a key role in planning and executing a variety of events, from corporate gatherings to private parties. You will work closely with clients, vendors, and team members to ensure each event runs smoothly and meets expectations.',
        ],
        responsibilities: [
            'Coordinating all aspects of event planning and execution.',
            'Communicating with clients to understand event goals.',
            'Managing vendor relationships and service contracts.',
            'Monitoring event timelines and budgets.',
            'Overseeing event setup, execution, and breakdown.',
        ],
        qualifications: [
            'Bachelor’s degree in Event Management, Hospitality, or related field.',
            'Experience with event planning and logistics.',
            'Strong organizational and multitasking skills.',
            'Excellent communication and interpersonal abilities.',
            'Detail-oriented with a passion for event coordination.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Bridal Stylist',
        content: 'Join our team as a Bridal Stylist and help brides find their perfect look for the big day.',
        details: {
            location: 'Company, City',
            timing: 'Full Time / Part Time',
            hours: 'Flexible Shifts, Including Weekends',
            experience: '1–2 Years in Fashion or Bridal Styling',
            position: 'Limited Positions Available',
            days: 'Rotational Schedule Including Saturdays & Sundays',
            salary: '$40K - $50K',
            deadline: 'Apply Now - Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are looking for a passionate Bridal Stylist who can assist clients in selecting the ideal wedding attire. You will offer personalized consultations, provide fashion guidance, and create a memorable dress-shopping experience for each bride-to-be.',
        ],
        responsibilities: [
            'Assisting brides in selecting wedding dresses and accessories.',
            'Providing fashion advice based on body type, style, and preferences.',
            'Maintaining store appearance and dress inventory.',
            'Scheduling appointments and managing client relationships.',
            'Staying up-to-date on bridal fashion trends.',
        ],
        qualifications: [
            'Background in Fashion, Retail, or related field.',
            'Experience in bridal or formalwear styling preferred.',
            'Excellent communication and customer service skills.',
            'Eye for detail and styling aesthetics.',
            'Friendly and patient demeanor with a passion for weddings.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Floral Designer',
        content: 'Design breathtaking floral arrangements that bring wedding visions to life.',
        details: {
            location: 'Company, City',
            timing: 'Full Time / Freelance',
            hours: 'Event-Based Hours, Including Weekends',
            experience: 'Minimum 2 Years in Floral Design',
            position: 'Few Positions Available',
            days: 'Flexible, Based on Event Schedule',
            salary: '$35K - $50K',
            deadline: 'Apply Now - Limited Slots Open',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are seeking a creative and detail-oriented Floral Designer to craft unique floral arrangements for weddings and special events. You will work closely with clients to match their themes, ensuring each bouquet, centerpiece, and installation reflects their personal style.',
        ],
        responsibilities: [
            'Designing floral concepts for various wedding themes.',
            'Arranging bouquets, centerpieces, and large installations.',
            'Collaborating with event planners and clients.',
            'Ordering flowers and managing floral inventory.',
            'Setting up floral arrangements on-site at venues.',
        ],
        qualifications: [
            'Proven experience as a Floral Designer or similar role.',
            'Strong sense of color, texture, and design.',
            'Ability to work under pressure and meet deadlines.',
            'Excellent communication and collaboration skills.',
            'Knowledge of flower care and seasonal availability.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Venue Coordinator',
        content: 'Ensure seamless execution of events at our venue with expert coordination.',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Event-Based Hours, Including Evenings and Weekends',
            experience: 'Minimum 2 Years in Event or Venue Coordination',
            position: 'Multiple Positions Available',
            days: 'Rotational Shifts, Including Weekends',
            salary: '$45K - $60K',
            deadline: 'Apply Now - Interviews Ongoing',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are looking for a detail-oriented and enthusiastic Venue Coordinator to manage event logistics at our venue. This role involves working directly with clients, vendors, and staff to ensure flawless events from start to finish.',
        ],
        responsibilities: [
            'Coordinating event setup, execution, and breakdown.',
            'Serving as the main point of contact for clients during events.',
            'Managing timelines and ensuring adherence to schedules.',
            'Liaising with vendors and service providers.',
            'Ensuring compliance with venue policies and safety standards.',
        ],
        qualifications: [
            'Experience in venue or event coordination.',
            'Strong organizational and multitasking skills.',
            'Excellent interpersonal and communication skills.',
            'Ability to work in a fast-paced, event-driven environment.',
            'Problem-solving mindset and customer service orientation.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Catering Manager',
        content: 'Lead our catering operations with culinary expertise and organizational excellence.',
        details: {
            location: 'Company, City',
            timing: 'Full Time',
            hours: 'Flexible Schedule, Including Events and Weekends',
            experience: 'Minimum 3 Years in Catering or Hospitality Management',
            position: 'Single Position Available',
            days: 'Weekdays and Event-Based Weekends',
            salary: '$55K - $70K',
            deadline: 'Apply Now - Position Open Until Filled',
            phoneNumber: '123-456-7890',
        },
        overviews: [
            'We are hiring a Catering Manager to oversee the planning and execution of our catering services. This role requires strong leadership, excellent communication skills, and a passion for delivering outstanding guest experiences through food service.',
        ],
        responsibilities: [
            'Managing catering operations and staff.',
            'Coordinating with clients to customize menus and services.',
            'Ensuring high-quality food presentation and service.',
            'Monitoring inventory and placing supply orders.',
            'Maintaining health, safety, and cleanliness standards.',
        ],
        qualifications: [
            'Degree in Hospitality Management or related field.',
            'Proven experience in catering or food service management.',
            'Strong organizational and time-management abilities.',
            'Excellent communication and leadership skills.',
            'Customer-focused approach with attention to detail.',
        ],
    }
];

export { positions, benefits, careerIntro };